/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {css} from "emotion";

// Vite serves assets as URL strings via ESM import (webpack-style require() is
// unavailable in the browser). One import per unique asset, generated mechanically.
import __asset_0 from "@res/icons/ir-logo.svg";
import __asset_1 from "@res/icons/icon_ir_logo_new_white.png";
import __asset_2 from "@res/icons/elliq_logo.svg";
import __asset_3 from "@res/icons/cc-logo.svg";
import __asset_4 from "@res/icons/metro_logo.png";
import __asset_5 from "@res/icons/check.png";
import __asset_6 from "@res/icons/check_green.png";
import __asset_7 from "@res/icons/clock.png";
import __asset_8 from "@res/icons/icon_schedule.svg";
import __asset_9 from "@res/icons/icon-avatar-male.svg";
import __asset_10 from "@res/icons/icon-avatar-female.svg";
import __asset_11 from "@res/icons/icon_info_pressed.svg";
import __asset_12 from "@res/icons/icon_tick_blue_.png";
import __asset_13 from "@res/icons/icon_patients.svg";
import __asset_14 from "@res/icons/icon_arrowhead_dropdown.svg";
import __asset_15 from "@res/icons/icon_compose_message.svg";
import __asset_16 from "@res/icons/icon-patient-pressed.svg";
import __asset_17 from "@res/icons/icon_messages.svg";
import __asset_18 from "@res/icons/icon-communication.svg";
import __asset_19 from "@res/icons/icon__bell.svg";
import __asset_20 from "@res/icons/icon-bell.svg";
import __asset_21 from "@res/icons/icon_bell_s.svg";
import __asset_22 from "@res/icons/icon__close.svg";
import __asset_23 from "@res/icons/icon__email.svg";
import __asset_24 from "@res/icons/icn_send.svg";
import __asset_25 from "@res/icons/button_send_pressed.svg";
import __asset_26 from "@res/icons/icon__errorToast.svg";
import __asset_27 from "@res/icons/icon_cross_s.svg";
import __asset_28 from "@res/icons/icon_warning.svg";
import __asset_29 from "@res/icons/icn_magnifier.svg";
import __asset_30 from "@res/icons/icon__infoToast.svg";
import __asset_31 from "@res/icons/icn_warning_circle.svg";
import __asset_32 from "@res/icons/icon_extract.svg";
import __asset_33 from "@res/icons/icon_expand.svg";
import __asset_34 from "@res/icons/icon__successToast.svg";
import __asset_35 from "@res/icons/icon__triangle_down.svg";
import __asset_36 from "@res/icons/icon__triangle_up.svg";
import __asset_37 from "@res/icons/icon__v.svg";
import __asset_38 from "@res/icons/icon__x.svg";
import __asset_39 from "@res/icons/icon_update.svg";
import __asset_40 from "@res/icons/icon-info.svg";
import __asset_41 from "@res/icons/icon-arrowhead-dark-l.svg";
import __asset_42 from "@res/icons/icon_arrowhead_down_s.svg";
import __asset_43 from "@res/icons/icon_arrow_replied.svg";
import __asset_44 from "@res/icons/icon_hourglass.svg";
import __asset_45 from "@res/icons/icon_envelope.svg";
import __asset_46 from "@res/icons/icon-arrowhead-dark-xl-left.svg";
import __asset_47 from "@res/icons/icon-arrowhead-dark-xl-right.svg";
import __asset_48 from "@res/icons/icon_arrowhead_dark_xl_up.svg";
import __asset_49 from "@res/icons/icon_arrowhead_dark_xl_down.svg";
import __asset_50 from "@res/icons/icn-arrows.svg";
import __asset_51 from "@res/icons/icon-statoscope.svg";
import __asset_52 from "@res/icons/icon_medical_suitcase.svg";
import __asset_53 from "@res/icons/icon-task-folder.svg";
import __asset_54 from "@res/icons/download.svg";
import __asset_55 from "@res/icons/icon_alert.svg";
import __asset_56 from "@res/icons/sun.svg";
import __asset_57 from "@res/icons/sun_checkin.svg";
import __asset_58 from "@res/icons/moon.svg";
import __asset_59 from "@res/icons/edit.svg";
import __asset_60 from "@res/icons/alert_complete.svg";
import __asset_61 from "@res/icons/alert_complete_support.svg";
import __asset_62 from "@res/icons/alert_new_support.svg";
import __asset_63 from "@res/icons/alert_on_hold.svg";
import __asset_64 from "@res/icons/alert_open_support.svg";
import __asset_65 from "@res/icons/alert_pending.svg";
import __asset_66 from "@res/icons/alert_attention_needed.svg";
import __asset_67 from "@res/icons/alert_status_triage.svg";
import __asset_68 from "@res/icons/alert_action.svg";
import __asset_69 from "@res/icons/icon_filters.svg";
import __asset_70 from "@res/icons/icn_question_mark_active.svg";
import __asset_71 from "@res/icons/icon_tick_blue.svg";
import __asset_72 from "@res/icons/icon_arrow_green_up.svg";
import __asset_73 from "@res/icons/icon_arrow_red_down.svg";
import __asset_74 from "@res/icons/icon_arrowhead_dropdown_dark.svg";
import __asset_75 from "@res/icons/arrow_right.svg";
import __asset_76 from "@res/icons/icon_voice.svg";
import __asset_77 from "@res/icons/icon_folder.svg";
import __asset_78 from "@res/icons/health_shield_blue.svg";
import __asset_79 from "@res/icons/health_shield_white.svg";
import __asset_80 from "@res/icons/plus_circle.svg";
import __asset_81 from "@res/icons/microphone.svg";
import __asset_82 from "@res/icons/microphone_recording.svg";
import __asset_83 from "@res/icons/button-record-hover.svg";
import __asset_84 from "@res/icons/button-stop.svg";
import __asset_85 from "@res/icons/icon-trash.svg";
import __asset_86 from "@res/icons/icon-trash-hover.svg";
import __asset_87 from "@res/icons/icon_sentMessage.svg";
import __asset_88 from "@res/icons/icon_receivedMessage.svg";
import __asset_89 from "@res/icons/icon_failedMessage.svg";
import __asset_90 from "@res/icons/icon_readMessage.svg";
import __asset_91 from "@res/icons/icon_birthday.svg";
import __asset_92 from "@res/icons/icon_currentTime.svg";
import __asset_93 from "@res/icons/rsvp_pending.svg";
import __asset_94 from "@res/icons/rsvp_confirmed.svg";
import __asset_95 from "@res/icons/rsvp_reschedule.svg";
import __asset_96 from "@res/icons/rsvp_cancellation.svg";
import __asset_97 from "@res/icons/doctor_appointment.svg";
import __asset_98 from "@res/icons/icon_isolationMode.svg";

export const ir_logo = __asset_0;
export const new_ir_logo_white = __asset_1;
export const elliq_logo = __asset_2;
export const cc_logo_header = __asset_3;
export const metro_plus_logo = __asset_4;
export const check_icon = __asset_5;
export const check_green_icon = __asset_6;
export const clock_icon = __asset_7;
export const icon_schedule_src = __asset_8;
export const icon_avatar_male = __asset_9;
export const icon_avatar_female = __asset_10;
export const icon_info_pressed_img = __asset_11;

// PNG is being used here for css purposes
export const icon_tick_blue_ = __asset_12;

export type IconStyle = {
	color: string;
	width: number;
	height: number;
}

type Props = {
	iconStyle: IconStyle
	iconData: IconData
}

class RenderIcon
	extends React.Component<Props> {

	render() {
		const key = this.props.iconData.key;
		const value = this.props.iconData.value;
		const iconStyle = css`
      width: ${this.props.iconStyle.width}px;
      height: ${this.props.iconStyle.height}px;
      background: ${this.props.iconStyle.color};
      -webkit-mask-image: url("${value}");
      mask-image: url("${value}");
      mask-size: cover;
      display: inline-block;
		`;

		return <span id={key} className={iconStyle}/>;
	}
}


export type IconData = {
	ratio: number,
	key: string,
	value: string
}

export const iconsRenderer = (iconData: IconData, color?: string, width: number = 24) => {
	return <RenderIcon iconData={iconData} iconStyle={{color: color || "#000000", height: width * iconData.ratio, width: width}}/>;
};

const icon_patients = {key: "icon_patients", ratio: 25 / 18, value: __asset_13};
const icon_arrowhead_dropdown = {key: "icon_patients", ratio: 25 / 18, value: __asset_14};
const icon_compose_message = {key: "icon_compose_message", ratio: 25 / 18, value: __asset_15};
const icon_patient_pressed = {key: "icon_patient_pressed", ratio: 48 / 48, value: __asset_16};
const icon_messages = {key: "icon_messages", ratio: 25 / 18, value: __asset_17};
const icon_communication = {key: "icon_communication", ratio: 48 / 48, value: __asset_18};
const bell: IconData = {key: "bell", ratio: 24 / 24, value: __asset_19};
const bell_empty: IconData = {key: "bell", ratio: 24 / 24, value: __asset_20};
const icon_bell_s: IconData = {key: "icon_bell_s", ratio: 24 / 24, value: __asset_21};
const close: IconData = {key: "close", ratio: 10 / 10, value: __asset_22};
const email: IconData = {key: "email", ratio: 24 / 24, value: __asset_23};
const send: IconData = {key: "email", ratio: 24 / 24, value: __asset_24};
const button_send_pressed: IconData = {key: "email", ratio: 24 / 24, value: __asset_25};
const errorToast: IconData = {key: "errorToast", ratio: 24 / 26, value: __asset_26};
const icon_cross_s: IconData = {key: 'icon_cross_s', ratio: 24 / 24, value: __asset_27};
const icon_warning: IconData = {key: 'icon_warning', ratio: 24 / 24, value: __asset_28};
const search: IconData = {key: 'icon_search', ratio: 27 / 24, value: __asset_29};
const infoToast: IconData = {key: "infoToast", ratio: 24 / 26, value: __asset_30};
const warning_circle: IconData = {key: "infoToast", ratio: 24 / 26, value: __asset_31};
const extract: IconData = {key: "extract", ratio: 24 / 24, value: __asset_32};
const expand: IconData = {key: "extract", ratio: 24 / 24, value: __asset_33};
const successToast: IconData = {key: "successToast", ratio: 24 / 26, value: __asset_34};
const triangle_down: IconData = {key: "triangle_down", ratio: 5 / 6, value: __asset_35};
const triangle_up: IconData = {key: "triangle_up", ratio: 5 / 6, value: __asset_36};
const v: IconData = {key: "v", ratio: 24 / 26, value: __asset_37};
const x: IconData = {key: "x", ratio: 24 / 26, value: __asset_38};
const icon_update: IconData = {key: "icon_update", ratio: 1, value: __asset_39};
const icon_info: IconData = {key: "icon_info", ratio: 1, value: __asset_40};
const icon_arrowhead_dark_l: IconData = {key: "icon_arrowhead_dark_l", ratio: 1, value: __asset_41};
const icon_arrow_down: IconData = {key: "arrowhead_down_s", ratio: 24 / 24, value: __asset_42};
const icon_arrow_replied: IconData = {key: "icon_arrow_replied", ratio: 26 / 26, value: __asset_43};
const icon_hourglass: IconData = {key: "icon_hourglass", ratio: 24 / 24, value: __asset_44};
const icon_envelope: IconData = {key: "icon_envelope", ratio: 26 / 26, value: __asset_45};
const icon_arrowhead_xl_left: IconData = {key: "arrowhead_down_s", ratio: 24 / 24, value: __asset_46};
const icon_arrowhead_xl_right: IconData = {key: "arrowhead_down_s", ratio: 24 / 24, value: __asset_47};
const icon_arrowhead_xl_up: IconData = {key: "icon_arrowhead_xl_up", ratio: 24 / 24, value: __asset_48};
const icon_arrowhead_xl_down: IconData = {key: "icon_arrowhead_xl_down", ratio: 24 / 24, value: __asset_49};
const icon_arrows: IconData = {key: "icon_arrows", ratio: 14 / 8, value: __asset_50};
const icon_statoscope: IconData = {key: "arrowhead_down_s", ratio: 24 / 24, value: __asset_51};
const icon_medical_suitcase: IconData = {key: "icon_medical_suitcase", ratio: 24 / 24, value: __asset_52};
const icon_task_folder: IconData = {key: "icon_arrows", ratio: 24 / 24, value: __asset_53};
const icon_download: IconData = {key: "icon_download", ratio: 24 / 24, value: __asset_54};
const icon_alert: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_55};
const icon_sun: IconData = {key: "icon_sun", ratio: 24 / 24, value: __asset_56};
const icon_sun_checkin: IconData = {key: "icon_sun_checkin", ratio: 1, value: __asset_57};
const icon_moon: IconData = {key: "icon_moon", ratio: 24 / 24, value: __asset_58};
const icon_edit: IconData = {key: "icon_edit", ratio: 24 / 24, value: __asset_59};
const alert_complete: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_60};
const alert_complete_support: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_61};
const alert_new_support: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_62};
const alert_on_hold: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_63};
const alert_open_support: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_64};
const alert_pending: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_65};
const alert_attention_needed: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_66};
const alert_triage: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_67};
const alert_action: IconData = {key: "icon_alert", ratio: 24 / 24, value: __asset_68};
const icon_info_pressed: IconData = {key: "icon_info_pressed", ratio: 16 / 16, value: __asset_11};
const icon_filters: IconData = {key: "close", ratio: 24 / 24, value: __asset_69};
const icon_question: IconData = {key: "close", ratio: 24 / 24, value: __asset_70};
const icon_tick_blue: IconData = {key: "close", ratio: 24 / 24, value: __asset_71};
const icon_arrow_green_up: IconData = {key: "close", ratio: 24 / 24, value: __asset_72};
const icon_arrow_red_down: IconData = {key: "close", ratio: 24 / 24, value: __asset_73};
const icon_arrowhead_dropdown_dark: IconData = {key: "close", ratio: 24 / 24, value: __asset_74};
const arrow_right: IconData = {key: "close", ratio: 24 / 24, value: __asset_75};
const icon_voice: IconData = {key: "icon_voice", ratio: 16 / 16, value: __asset_76};
const icon_folder: IconData = {key: "icon_voice", ratio: 14 / 16, value: __asset_77};
const health_shield_blue: IconData = {key: "health_shield_blue", ratio: 18 / 14, value: __asset_78};
const health_shield_white: IconData = {key: "health_shield_white", ratio: 18 / 14, value: __asset_79};
const plus_circle: IconData = {key: "plus_circle", ratio: 15 / 15, value: __asset_80};
const microphone: IconData = {key: "microphone", ratio: 24 / 24, value: __asset_81};
const microphone_recording: IconData = {key: "microphone_recording", ratio: 24 / 24, value: __asset_82};
const microphone_hovered: IconData = {key: "microphone_hovered", ratio: 24 / 24, value: __asset_83};
const button_stop: IconData = {key: "button-stop", ratio: 24 / 24, value: __asset_84};
const trash_can: IconData = {key: "trash_can", ratio: 24 / 24, value: __asset_85};
const trash_can_hovered: IconData = {key: "trash_can", ratio: 24 / 24, value: __asset_86};
const icon_sentMessage: IconData = {key: "icon_sentMessage", ratio: 24 / 24, value: __asset_87};
const icon_receivedMessage: IconData = {key: "icon_receivedMessage", ratio: 24 / 24, value: __asset_88};
const icon_failedMessage: IconData = {key: "icon_failedMessage", ratio: 24 / 24, value: __asset_89};
const icon_readMessage: IconData = {key: "icon_readMessage", ratio: 24 / 24, value: __asset_90};
const icon_birthday: IconData = {key: "icon_birthday", ratio: 28 / 22, value: __asset_91};
const icon_currentTime: IconData = {key: "icon_currentTime", ratio: 28 / 21, value: __asset_92};
const icon_schedule: IconData = {key: "icon_schedule", ratio: 1, value: __asset_8};
const rsvp_pending: IconData = {key: "rsvp_pending", ratio: 16 / 12, value: __asset_93};
const rsvp_confirmed: IconData = {key: "rsvp_pending", ratio: 16 / 16, value: __asset_94};
const rsvp_reschedule: IconData = {key: "rsvp_pending", ratio: 16 / 15, value: __asset_95};
const rsvp_cancellation: IconData = {key: "rsvp_pending", ratio: 16 / 16, value: __asset_96};
const doctor_appointment: IconData = {key: "doctor_appointment", ratio: 21 / 22, value: __asset_97};
const isolation_mode: IconData = {key: "isolation_mode", ratio: 16 / 16, value: __asset_98}

export const ICONS = {
	icon_alert: (color?: string, width?: number) => iconsRenderer(icon_alert, color, width),
	icon_sun: (color?: string, width?: number) => iconsRenderer(icon_sun, color, width),
	icon_sun_checkin: (color?: string, width?: number) => iconsRenderer(icon_sun_checkin, color, width),
	icon_moon: (color?: string, width?: number) => iconsRenderer(icon_moon, color, width),
	icon_update: (color?: string, width?: number) => iconsRenderer(icon_update, color, width),
	attention_needed: (color?: string, width?: number) => iconsRenderer(alert_attention_needed, color, width),
	alert_triage: (color?: string, width?: number) => iconsRenderer(alert_triage, color, width),
	alert_complete: (color?: string, width?: number) => iconsRenderer(alert_complete, color, width),
	alert_complete_support: (color?: string, width?: number) => iconsRenderer(alert_complete_support, color, width),
	alert_new_support: (color?: string, width?: number) => iconsRenderer(alert_new_support, color, width),
	alert_on_hold: (color?: string, width?: number) => iconsRenderer(alert_on_hold, color, width),
	alert_open_support: (color?: string, width?: number) => iconsRenderer(alert_open_support, color, width),
	alert_pending: (color?: string, width?: number) => iconsRenderer(alert_pending, color, width),
	alert_action: (color?: string, width?: number) => iconsRenderer(alert_action, color, width),
	icon_patients: (color?: string, width?: number) => iconsRenderer(icon_patients, color, width),
	arrow_right: (color?: string, width?: number) => iconsRenderer(arrow_right, color, width),
	icon_arrowhead_dropdown: (color?: string, width?: number) => iconsRenderer(icon_arrowhead_dropdown, color, width),
	icon_compose: (color?: string, width?: number) => iconsRenderer(icon_compose_message, color, width),
	icon_patient_pressed: (color?: string, width?: number) => iconsRenderer(icon_patient_pressed, color, width),
	icon_messages: (color?: string, width?: number) => iconsRenderer(icon_messages, color, width),
	icon_communication: (color?: string, width?: number) => iconsRenderer(icon_communication, color, width),
	bell: (color?: string, width?: number) => iconsRenderer(bell, color, width),
	bell_empty: (color?: string, width?: number) => iconsRenderer(bell_empty, color, width),
	close: (color?: string, width?: number) => iconsRenderer(close, color, width),
	email: (color?: string, width?: number) => iconsRenderer(email, color, width),
	send: (color?: string, width?: number) => iconsRenderer(send, color, width),
	send_activate: (color?: string, width?: number) => iconsRenderer(button_send_pressed, color, width),
	warning_circle: (color?: string, width?: number) => iconsRenderer(warning_circle, color, width),
	extract: (color?: string, width?: number) => iconsRenderer(extract, color, width),
	expand: (color?: string, width?: number) => iconsRenderer(expand, color, width),
	errorToast: (color?: string, width?: number) => iconsRenderer(errorToast, color, width),
	infoToast: (color?: string, width?: number) => iconsRenderer(infoToast, color, width),
	successToast: (color?: string, width?: number) => iconsRenderer(successToast, color, width),
	triangle_down: (color?: string, width?: number) => iconsRenderer(triangle_down, color, width),
	triangle_up: (color?: string, width?: number) => iconsRenderer(triangle_up, color, width),
	v: (color?: string, width?: number) => iconsRenderer(v, color, width),
	x: (color?: string, width?: number) => iconsRenderer(x, color, width),
	health_shield_white: (color?: string, width?: number) => iconsRenderer(health_shield_white, color, width),
	health_shield_blue: (color?: string, width?: number) => iconsRenderer(health_shield_blue, color, width),
	icon_arrow_down: (color?: string, width?: number) => iconsRenderer(icon_arrow_down, color, width),
	icon_cross_s: (color?: string, width?: number) => iconsRenderer(icon_cross_s, color, width),
	icon_warning: (color?: string, width?: number) => iconsRenderer(icon_warning, color, width),
	search: (color?: string, width?: number) => iconsRenderer(search, color, width),
	icon_info: (color?: string, width?: number) => iconsRenderer(icon_info, color, width),
	icon_arrowhead_dark_l: (color?: string, width?: number) => iconsRenderer(icon_arrowhead_dark_l, color, width),
	icon_arrow_replied: (color?: string, width?: number) => iconsRenderer(icon_arrow_replied, color, width),
	icon_hourglass: (color?: string, width?: number) => iconsRenderer(icon_hourglass, color, width),
	icon_envelope: (color?: string, width?: number) => iconsRenderer(icon_envelope, color, width),
	icon_arrowhead_xl_left: (color?: string, width?: number) => iconsRenderer(icon_arrowhead_xl_left, color, width),
	icon_arrowhead_xl_right: (color?: string, width?: number) => iconsRenderer(icon_arrowhead_xl_right, color, width),
	icon_arrowhead_xl_up: (color?: string, width?: number) => iconsRenderer(icon_arrowhead_xl_up, color, width),
	icon_arrowhead_xl_down: (color?: string, width?: number) => iconsRenderer(icon_arrowhead_xl_down, color, width),
	icon_arrows: (color?: string, width?: number) => iconsRenderer(icon_arrows, color, width),
	icon_statoscope: (color?: string, width?: number) => iconsRenderer(icon_statoscope, color, width),
	icon_medical_suitcase: (color?: string, width?: number) => iconsRenderer(icon_medical_suitcase, color, width),
	icon_task_folder: (color?: string, width?: number) => iconsRenderer(icon_task_folder, color, width),
	icon_download: (color?: string, width?: number) => iconsRenderer(icon_download, color, width),
	icon_info_pressed: (color?: string, width?: number) => iconsRenderer(icon_info_pressed, color, width),
	icon_filters: (color?: string, width?: number) => iconsRenderer(icon_filters, color, width),
	icon_question: (color?: string, width?: number) => iconsRenderer(icon_question, color, width),
	icon_tick_blue: (color?: string, width?: number) => iconsRenderer(icon_tick_blue, color, width),
	icon_arrow_green_up: (color?: string, width?: number) => iconsRenderer(icon_arrow_green_up, color, width),
	icon_arrow_red_down: (color?: string, width?: number) => iconsRenderer(icon_arrow_red_down, color, width),
	icon_arrowhead_dropdown_dark: (color?: string, width?: number) => iconsRenderer(icon_arrowhead_dropdown_dark, color, width),
	icon_bell_s: (color?: string, width?: number) => iconsRenderer(icon_bell_s, color, width),
	icon_voice: (color?: string, width?: number) => iconsRenderer(icon_voice, color, width),
	plus_circle: (color?: string, width?: number) => iconsRenderer(plus_circle, color, width),
	microphone: (color?: string, width?: number) => iconsRenderer(microphone, color, width),
	microphone_recording: (color?: string, width?: number) => iconsRenderer(microphone_recording, color, width),
	microphone_hovered: (color?: string, width?: number) => iconsRenderer(microphone_hovered, color, width),
	button_stop: (color?: string, width?: number) => iconsRenderer(button_stop, color, width),
	trash_can: (color?: string, width?: number) => iconsRenderer(trash_can, color, width),
	trash_can_hovered: (color?: string, width?: number) => iconsRenderer(trash_can_hovered, color, width),
	icon_folder: (color?: string, width?: number) => iconsRenderer(icon_folder, color, width),
	icon_sentMessage: (color?: string, width?: number) => iconsRenderer(icon_sentMessage, color, width),
	icon_receivedMessage: (color?: string, width?: number) => iconsRenderer(icon_receivedMessage, color, width),
	icon_failedMessage: (color?: string, width?: number) => iconsRenderer(icon_failedMessage, color, width),
	icon_readMessage: (color?: string, width?: number) => iconsRenderer(icon_readMessage, color, width),
	icon_birthday: (color?: string, width?: number) => iconsRenderer(icon_birthday, color, width),
	icon_currentTime: (color?: string, width?: number) => iconsRenderer(icon_currentTime, color, width),
	icon_schedule: (color?: string, width?: number) => iconsRenderer(icon_schedule, color, width),
	icon_rsvp_pending: (color?: string, width?: number) => iconsRenderer(rsvp_pending, color, width),
	icon_rsvp_confirmed: (color?: string, width?: number) => iconsRenderer(rsvp_confirmed, color, width),
	icon_rsvp_reschedule: (color?: string, width?: number) => iconsRenderer(rsvp_reschedule, color, width),
	icon_rsvp_cancellation: (color?: string, width?: number) => iconsRenderer(rsvp_cancellation, color, width),
	doctor_appointment: (color?: string, width?: number) => iconsRenderer(doctor_appointment, color, width),
	isolation_mode: (color?: string, width?: number) => iconsRenderer(isolation_mode, color, width),
	icon_edit: (color?: string, width?: number) => iconsRenderer(icon_edit, color, width),
};
